<template>
    <div class="flowSearch flex flex_wrap align_center">
        <div class="time" :class="{ focus: flowDatePicker.timeKey === searchTimeKeyDef.alldays }" @click="onChangeTimeKey(searchTimeKeyDef.alldays)">全部</div>
        <div class="time" :class="{ focus: flowDatePicker.timeKey === searchTimeKeyDef.last7days }" @click="onChangeTimeKey(searchTimeKeyDef.last7days)">最近7天</div>
        <div class="time" :class="{ focus: flowDatePicker.timeKey === searchTimeKeyDef.last30days }" @click="onChangeTimeKey(searchTimeKeyDef.last30days)">最近30天</div>
        <div class="time" :class="{ focus: flowDatePicker.timeKey === searchTimeKeyDef.thismonth }" @click="onChangeTimeKey(searchTimeKeyDef.thismonth)">本月</div>
        <DatePicker
            v-model="flowDatePicker.value"
            :transfer="true"
            split-panels
            confirm
            :editable="false"
            type="daterange"
            class="width_200"
            placeholder="自定义时间"
            @on-open-change="$event => onDateOpenChangeDate($event)"
            @on-change="$event => onDateChange($event)"
        ></DatePicker>

        <Button type="primary" @click="onSearchFlow">查询</Button>
    </div>
</template>
<script>
const searchTimeKeyDef = {
    alldays: 'alldays',
    last7days: 'last7days',
    last30days: 'last30days',
    thismonth: 'thismonth',
    customtime: 'customtime',
};
export default {
    name: 'dateSearch',
    data() {
        this.searchTimeKeyDef = searchTimeKeyDef;
        return {
            flowDatePicker: {
                loading: false,
                value: null,
                timeKey: searchTimeKeyDef.last7days,
                sDate: '',
                eDate: '',
            },
        };
    },
    mounted() {
        // console.log('dataSearch mounted');
        this.onSearchFlow();
    },
    methods: {
        onDateOpenChangeDate(open) {
            if (open) {
                this.onChangeTimeKey(searchTimeKeyDef.customtime);
            } else {
                let { sDate, eDate } = this.flowDatePicker;
                if (!sDate || !eDate) {
                    this.onDateClear();
                }
            }
        },
        onDateChange(date) {
            let [sDate, eDate] = date;
            if (!!sDate && !!eDate) {
                let diffTime = new Date(eDate.replace(/-/g, '/')).getTime() - new Date(sDate.replace(/-/g, '/')).getTime();
                let days = diffTime / 1000 / 60 / 60 / 24;
                if (days > 60) {
                    this.$Notice.error({
                        title: '温馨提示',
                        desc: '日期范围不能大于60',
                        duration: 5,
                    });
                }
            }
            this.flowDatePicker.sDate = sDate;
            this.flowDatePicker.eDate = eDate;
            // console.log('onDateChange------>', date);
        },
        onDateClear() {
            // console.log('onDateClear');
            this.$set(this.flowDatePicker, 'timeKey', searchTimeKeyDef.last7days);
        },
        onChangeTimeKey(timekey) {
            // console.log('onChangeTimeKey------>', timekey);
            if (timekey !== searchTimeKeyDef.customtime) {
                this.$set(this.flowDatePicker, 'value', null);
                this.flowDatePicker.sDate = '';
                this.flowDatePicker.eDate = '';
            }
            this.$set(this.flowDatePicker, 'timeKey', timekey);
            if (timekey !== searchTimeKeyDef.customtime) {
                this.onSearchFlow();
            }
        },
        getDateByKey(timeKey) {
            let today = new Date();
            let FORMAT = 'yyyy-MM-dd';
            let sDate = '',
                eDate = today.Format(FORMAT);

            if (timeKey == searchTimeKeyDef.alldays) {
                return { sDate: '', eDate: '' };
            }
            if (timeKey == searchTimeKeyDef.last7days) {
                sDate = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000).Format(FORMAT);
                return { sDate, eDate };
            }
            if (timeKey == searchTimeKeyDef.last30days) {
                sDate = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000).Format(FORMAT);
                return { sDate, eDate };
            }

            today.setDate(1);
            sDate = today.Format(FORMAT);
            let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            eDate = lastDay.Format(FORMAT);
            return { sDate, eDate };
        },
        onSearchFlow() {
            if (this.flowDatePicker.timeKey !== searchTimeKeyDef.customtime) {
                let { sDate, eDate } = this.getDateByKey(this.flowDatePicker.timeKey);
                this.flowDatePicker.sDate = sDate;
                this.flowDatePicker.eDate = eDate;
            }
            this.flowDatePicker.loading = true;

            this.$emit('search', [this.flowDatePicker.sDate, this.flowDatePicker.eDate]);
        },
    },
};
</script>
<style lang="less" scoped>
.flowSearch {
    gap: 10px 20px;
    font-size: 16px;
    color: #000;

    .time {
        position: relative;
        width: fit-content;
        cursor: pointer;
        height: 50px;
        line-height: 50px;

        &.focus {
            color: #4c56c0;
        }

        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 3px;
            left: 0;
            bottom: 0;
            background-color: #4c56c0;
            transform: scaleX(0);
            transition: transform 0.2s linear;
        }

        &.focus::after {
            transform: scaleX(1);
        }
    }
}
</style>
